import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ReferenceDocument } from "@shared/models/cat.model";
import { ClaimReferenceDetails } from "../../model/claim-reference-details";
import { UserAddedAnchorResult } from "@shared/models/common";


@Component({
    selector: 'claim-references-editor',
    templateUrl: './claim-references-editor.component.html',
    styleUrls: ['./claim-references-editor.component.scss'],
    standalone: false
})
export class ClaimReferencesEditor implements OnInit {

    @Input({required: true}) claimReference!: ClaimReferenceDetails;
    @Input() catVersionId!: number;
    @Input() mode: 'create' | 'edit' | 'view' = 'create';
    
    @Input() claimReferences: ClaimReferenceDetails[] | null = null;
    @Input() filteredRefDocs: ReferenceDocument[] = [];
    @Input() refDocs: ReferenceDocument[] = [];

    @Output() removeClaimReference = new EventEmitter<ClaimReferenceDetails>();

    
    selectedRefDoc?: ReferenceDocument;

    anchors: UserAddedAnchorResult[] | null = null;
    selectedAnchor: UserAddedAnchorResult | null = null;
    //showAnchors: boolean = false;
    showAddContextDropdown: {
        value: boolean
    } = {
            value: false
        };

    constructor() {}

    ngOnInit(): void {

        if (this.mode !== 'create') {

            this.selectedRefDoc = this.refDocs.find((refDoc) => refDoc.docId == this.claimReference.refDocId);

            // try to match existing explicit reference without ref doc via reference mappings, so anchors can be added.
            // matched ref doc is not set on the reference - it is sent only once anchors are added
            if (!this.selectedRefDoc && this.claimReference.alreadyExists && this.claimReference.referenceType == 'EXPLICIT' && this.claimReference.refDocId == null) {

                this.selectedRefDoc = this.matchRefDoc(this.claimReference.refPhraseText);
            }
        }

    }

    get isImplicit(): boolean {
        return this.claimReference.referenceType == 'IMPLICIT';
    }

    // first ref doc with matching reference mapping, otherwise first ref doc with matching doc name
    private matchRefDoc(refText: string): ReferenceDocument | undefined {

        const cleanRefText = refText?.trim();
        if (!cleanRefText) {
            return undefined;
        }
        return this.refDocs.find((refDoc) => (refDoc.mappedReferenceTexts || []).some((mappedText) => mappedText?.trim() === cleanRefText)) ??
            this.refDocs.find((refDoc) => refDoc.docName?.trim() === cleanRefText);
    }
    
    onRefDocSelect() {
        
        if (!this.selectedRefDoc) {
            
            return;
        }
        const refDoc = this.selectedRefDoc;
        // add ref doc to claim references
        // display its anchors
        // send request for anchors
        let index = this.filteredRefDocs.findIndex(doc => doc == this.selectedRefDoc);
        if (index != -1) {
            this.filteredRefDocs.splice(index, 1);
        }
        let mappedReferenceText = refDoc.mappedReferenceTexts;
        let referenceText = refDoc.docName;
        if (mappedReferenceText && mappedReferenceText.length > 0) {

            let mappedRefText = mappedReferenceText.find((refText) => refText != "" && refText != null);
            if (mappedRefText != undefined) {

                referenceText = mappedRefText;

            }
        }

        this.claimReference.refDocId = refDoc.docId;
        // implicit references display ref doc name
        this.claimReference.refPhraseText = this.isImplicit ? refDoc.docName : referenceText;
        this.claimReference.anchors = [];
        this.claimReference.isConsistencyGenerated = false;


    }

    removedAnchor() {

        this.showAddContextDropdown.value = false;

    }


    toggleAnchorsDisplay() {

        this.showAddContextDropdown.value = !this.showAddContextDropdown.value;

    }

    removeReference() {
        
        this.removeClaimReference.emit(this.claimReference);
        if (this.selectedRefDoc && !this.filteredRefDocs.includes(this.selectedRefDoc)) {

            this.filteredRefDocs.push(this.selectedRefDoc);
        }
        
    }   
} 